import { render, staticRenderFns } from "./BuyerDataRegister.vue?vue&type=template&id=aca8bcc4&"
import script from "./BuyerDataRegister.vue?vue&type=script&lang=js&"
export * from "./BuyerDataRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports